import axios from "axios";
import { apiCall } from "@/common/api/ApiResult.model";
import { AdminUser, UserStatus } from "./models";
import { Restriction } from "@/common/models/admin-restrictions.model";

export const getAdmins = apiCall<void, AdminUser[]>("admins.get", async () => {
  const res = await axios.get("/admins");
  return {
    success: true,
    value: res.data,
  };
});

export const changeAdminStatus = apiCall(
  "admins.change",
  async (p: { id: number; status: UserStatus }) => {
    const res = await axios.patch(`/admins/${p.id}/status/${p.status}`);
    return {
      success: true,
      value: res.data,
    };
  }
);

/* 
reasons - 1 : user exist , 2: invalid email  , 3: server error
*/
export const createAdmins = apiCall<
  { emails: string[]; restrictions: string[] },
  { success: AdminUser[]; failure: Array<{ email: string; reason: 1 | 2 | 3 }> }
>(
  "admins.invite",
  async (payload: { emails: string[]; restrictions: string[] }) => {
    const res = await axios.post("/admins", payload);
    return {
      success: true,
      value: res.data,
    };
  }
);

export const get_restrictions = apiCall<void, string[]>(
  "admins.get-restrictions",
  async () => {
    const res = await axios.get("/admins/restrictions");
    return {
      success: true,
      value: res.data,
    };
  }
);

export const update_restrictions = apiCall<
  {
    admin: AdminUser;
    restrictions: Restriction[];
  },
  boolean
>("admins.update-restrictions", async ({ restrictions, admin }) => {
  await axios.post("/admins/restrictions", {
    userId: admin.id,
    restrictions,
    override: true,
  });
  return {
    success: true,
    value: true,
  };
});
